import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Dropdown, Carousel } from "react-bootstrap";
import axios from 'axios';
import moment from 'moment';



const Profit_Loss = () => {

    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [income, setIncome] = useState([]);
    const [expense, setEpense] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const [total_credit, settotalCredit] = useState(null);
    const [total_debit, settotalDebit] = useState(null);
    const [net_income, setnetIncome] = useState(null);

        // pagination
            const [page, setPage] = useState(1);
            const [totalPages, setTotalPages] = useState(1);
            const [searchTerm, setSearchTerm] = useState('');
            const [perPage, setPerPage] = useState(10);
            const [total, setTotal] = useState(0);

         const currentDate = new Date(); // Current date: June 18, 2025
    const currentMonth = currentDate.getMonth(); // 5 (June, 0-based index)
    // const currentYear = currentDate.getFullYear(); // 2025
     const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ].slice(0, currentMonth + 1);

  // Get current month index (0-11)
  const currentMonthIndex = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const [index, setIndex] = useState(currentMonth);
  const [month, setMonth] = useState(currentMonth+1);
  const [year, setYear] = useState(currentYear);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
    setMonth(selectedIndex+1);
  };

  useEffect(() => {
    setMonth(months[index]);
    setYear(currentYear); // Or make dynamic if changing years is needed
    // alert(month);
        // alert(perPage);
     const params = {
                // spread existing filter key-values
             page,           // add page number
             per_page: perPage, // add per_page
             search: searchTerm  // add search string
        };
        axios.get(`${baseURL}/manage-profit-loss?month=${index+1}&year=${year}&page=${page}&per_page=${perPage}&search=${searchTerm}`)
                    .then(response => {
                    // const daily_accounts = response.data.data;
                    const income = response.data.income.data;
                    // const expense = response.data.expense;
                      
                    const total_credit = response.data.total_credit;
                    const total_debit = response.data.total_debit;
                    const net_income = response.data.net_income;
                     const total_rec = response.data.income.total;
                    const last_page = response.data.income.last_page;

                    setTotal(total_rec);
                    setTotalPages(last_page);
                        // console.log("income--------->",income);
                    setIncome(income);
                    setEpense(expense);
                    settotalCredit(total_credit);
                    settotalDebit(total_debit);
                    setnetIncome(net_income);
                    setHasFetched(true);
    
                    })
                    .catch(error => {
                    console.log('Error fetching Profit Loss!', error);
                    setHasFetched(true);
                    });


  }, [index, page, searchTerm, perPage]);
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Profit & Loss</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Account Management</li>
                    </ol>
                </div>
            </div>

            <div className='row'>
                <div className='col-lg-6'>
                    <div className='mb-3'>
                        <Carousel
                            controls={true}
                            activeIndex={index}
                            onSelect={handleSelect}  // Dynamically update the active index
                            indicators={true}
                            interval={null}
                             nextIcon={index === months.length - 1 ? null : undefined}
                        >
                             {months.map((month, idx) => (
                            <Carousel.Item key={idx} className='text-center'>
                                <label className='fs-3 text-black fw-bold'>{month}</label>
                                <div className='d-block'>
                                    <label className='fs-3 text-danger fw-bold'>{year}</label>
                                </div>
                            </Carousel.Item>
                             ))}
                            {/* <Carousel.Item key={2} className='text-center'>
                                <label className='fs-3 text-black fw-bold'>February</label>
                                <div className='d-block'>
                                    <label className='fs-3 text-danger fw-bold'>2025</label>
                                </div>
                            </Carousel.Item>
                            <Carousel.Item key={3} className='text-center'>
                                <label className='fs-3 text-black fw-bold'>March</label>
                                <div className='d-block'>
                                    <label className='fs-3 text-danger fw-bold'>2025</label>
                                </div>
                            </Carousel.Item> */}
                        </Carousel>
                    </div>
                </div>
                <div className='col-lg-6'>
                    <div className='d-flex align-items-end justify-content-end'>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-success bg-success-light'>
                                <label className='text-black fs-6'>Total Income</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                        <span>{total_credit}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-danger bg-danger-light '>
                                <label className='text-black fs-6'>Total Expense</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                        <span>{total_debit}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-info bg-info-light '>
                                <label className='text-black fs-6'>Net Income</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                        <span>{net_income}</span>
                                        <i class="fas fa-arrow-up ms-2 fs-2 text-primary"></i>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="table-container">
                   <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>
                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-125px'>Income</th>
                            <th>Amount</th>
                            <th className='min-w-125px'>Expense</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                            

                          {income.map(data => (
                        <tr>
                            {data.is_credit==1? (<>
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.ledger_name}</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.amount}</span>
                                </Badge>
                            </td>
                            </>
                                ):( <>
                            <td>
                                <label className='text-black font-w400 fs-7'>--</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>0</span>
                                </Badge>
                            </td>
                            </>)}
                                 {data.is_credit==0? (
                                <>
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.ledger_name}</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="danger" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.amount}</span>
                                </Badge>
                               
                            </td>
                            </>
                             ):( <>
                            <td>
                                <label className='text-black font-w400 fs-7'>--</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="danger" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>0</span>
                                </Badge>
                            </td>
                            </>)}
                           
                        
                        </tr>
                                
                           ))} 
                              {/* {income.map(data => (
                        <tr>
                             {data.is_credit==0? (<>
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.ledger_name}</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.amount}</span>
                                </Badge>
                            </td>
                             </>
                                ):(
                                <>
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.ledger_name}</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="danger" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.ledger_name}</span>
                                </Badge>
                            </td>
                              </>
                            )}
                        </tr>
 ))}  */}
                    </tbody>
                </table>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {income.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + income.length} of {total} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>
                                               {/* </div> */}

                {/* <div className='row d-flex justify-content-end mt-5'>
                    <div className='col-lg-4'>
                        <div className='row'>
                            <label className='col-lg-8 fs-5 font-w500 text-black'> Total Income (A)</label>
                            <div className='col-lg-4 text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-5'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>30,000</span>
                                </Badge>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <label className='col-lg-8 fs-5 font-w500 text-black'> Total Expense (B)</label>
                            <div className='col-lg-4 text-end'>
                                <Badge bg="danger" className='py-0 px-1 fs-5'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>50,000</span>
                                </Badge>
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <label className='col-lg-8 fs-4 font-w500 text-black'> Net Income</label>
                            <div className='col-lg-4 text-end'>
                                <label className="text-danger fs-2 m-0 font-w600">
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>5000</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>

        </>
    )


}
export default Profit_Loss;